import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Switch as MuiSwitch } from '@mui/material';

// Styled Switch component
const StyledSwitch = styled(MuiSwitch)(({ theme, color = 'primary' }) => ({
  width: 42,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette[color].main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
    borderRadius: '50%',
    transition: theme.transitions.create(['width'], {
      duration: 300,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    opacity: 0.5,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    boxSizing: 'border-box',
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
}));

// Switch component
const Switch = ({ color = 'primary', ...props }) => {
  return <StyledSwitch color={color} {...props} />;
};

Switch.propTypes = {
  /**
   * The color of the component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'success']),
  /**
   * If true, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
  /**
   * If true, the component is disabled.
   */
  disabled: PropTypes.bool,
};

export default Switch;
